
import 'modules/site';
import 'modules/Menu';
import 'modules/Images';
import 'modules/Parallax';
import 'modules/GravityForm';
import 'modules/Gallery';